<script lang="ts">
	import { env } from "$lib/env.client";
	import { onMount } from "svelte";
	import type { ClientUser } from "../../../models/ClientTypes";

	export let user: ClientUser;

	onMount(() => {
		window._cio = window._cio || [];
		(function () {
			var a, b, c;
			a = function (f) {
				return function () {
					window._cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
				};
			};
			b = ["load", "identify", "sidentify", "track", "page", "on", "off"];
			for (c = 0; c < b.length; c++) {
				window._cio[b[c]] = a(b[c]);
			}
			var t = document.createElement("script"),
				s = document.getElementsByTagName("script")[0];
			t.async = true;
			t.id = "cio-tracker";
			t.setAttribute("data-site-id", env.PUBLIC_CUSTOMER_IO___SAAS___SITE_ID!);
			t.setAttribute("data-use-array-params", "true");

			//Enables in-app messaging
			t.setAttribute("data-use-in-app", "true");

			t.src = "https://assets.customer.io/assets/track.js";
			s.parentNode.insertBefore(t, s);
		})();

		// For reference:
		//
		// const onMessageOpened = function (event) {
		//     console.log('Type: ', event.type);
		//     console.log('Message Id: ', event.detail.messageId);
		//     console.log('Delivery Id: ', event.detail.deliveryId); // not present in test messages
		// };

		// run the listener everytime message is shown
		// _cio.on('in-app:message-opened', onMessageOpened);

		// Identify the user. Otherwise, the in-app message won't work.
		// See: https://customer.io/docs/sdk/web/in-app/
		if (user) {
			window._cio.identify({
				email: user.email,
				id: user.email
			});
		}
	});
</script>
